module.exports = __webpack_public_path__ + "f7d3fde14bcf744714897c5dfca56ecd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-62@2x.png
// module id = 528
// module chunks = 0